import React, {Component} from 'react';
import './pScene8.css';
import {getSpan} from "../../../Utilities/utils";
import BgGrid from "../../BgGrid";
import c3 from "../../../Resources/Celu3.gif";

class PScene8 extends Component<> {

    render() {
        return (
            <section className={"p-container"}>
                <div id={'pscene8'} className='content'>
                    <BgGrid className={'p-bg-grid'} id='p_s8bg'
                            hLines={5} vLines={4} stroke={'black'} />
                    <h1 className={'p-text-container-scene-8'}>
                        <span id={'ps8-txt'} className={"p-text"}>
                            {getSpan(['phome_clients_txt', "phome_clients_txt_2", "phome_clients_txt_3"], 'ps8_txt', <span> </span>)}
                        </span>
                    </h1>
                    <img className={"ps8-big-phone accessibility-img"} src={c3} alt="celu 3"/>
                </div>
            </section>
        )
    }
}

export default PScene8;
